<template>
  <v-card flat style="background: transparent;">
    <v-card-text class="pa-0">
      <v-data-table
        style="background: transparent;"
        :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
        :headers="headers"
        :items="users"
        :search="search"
        :loading="loading"
        id="table_trustee"
        mobile-breakpoint=""
      >
        <template
          v-if="users.length"
          #body="{ items }"
        >
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              style="cursor:pointer;"
              :class="selectedRow === item.usr ? 'highlight' : null"
              @click="editPermissions({user: item.usr, acl: item.acl})"
            >
              <td>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>account_box</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.usr }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <template v-if="$vuetify.breakpoint.mdAndUp">
                <td>
                  <!-- <p>{{ item.acl }}</p> -->
                  <template v-for="(perm, key) in getPartitionPermissions({acl: item.acl})">
                    <v-tooltip :key="`perm-${key}`" top>
                      <template #activator="{ on }">
                        <v-chip
                          :id="item.usr + '_' + key"
                          v-on="on"
                          label
                          outlined
                          :color="perm.color"
                          class="mx-1 border-radius-0"
                        >
                          {{ key | upper }}
                        </v-chip>
                      </template>
                      <span>{{ perm.label }}</span>
                    </v-tooltip>
                  </template>
                </td>
              </template>
              <td>
                <v-row no-gutters justify="end">
                  <menu-actions
                    :id="`menu_actions_${item.usr}`"
                    :options="actionsList"
                    @open="optionsClick(item)"
                    @close="closeMenu"
                  />
                </v-row>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-else>
          <td
            v-if="loading"
          >
            {{ $t('searching') }}
          </td>

          <td
            v-else
          >
            {{ $t('$vuetify.noDataText') }}
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import MenuActions from '@/components/MenuActions.vue'

export default {
  components: { MenuActions },
  props: {
    search: {
      type: String,
      default: () => null
    }
  },
  created () {
    this.loadUsers()
  },
  data () {
    return {
      showPermissionsDeleteModal: false,
      loading: false,
      actionsList: [],
      selectedRow: null
    }
  },
  computed: {
    users () {
      return this.$store.state.user.trusteesList
    },
    headers () {
      const name = this.$tc('name', 2)
      const action = this.$tc('action', 2)
      const mobileHeaders = [
        {
          text: name,
          align: 'left',
          sortable: true,
          value: 'usr'
        },
        {
          text: action,
          align: 'right',
          sortable: false,
          value: null
        }
      ]

      const allHeaders = [
        {
          text: name,
          align: 'left',
          sortable: true,
          value: 'usr'
        },
        {
          text: 'Permissions',
          align: 'left',
          sortable: false,
          value: null
        },
        {
          text: action,
          align: 'right',
          sortable: false,
          value: null
        }
      ]
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm': return mobileHeaders
        case 'md':
        case 'lg':
        case 'xl': return allHeaders
        default: return allHeaders
      }
    }
  },
  methods: {
    loadUsers () {
      const user = this.$store.state.auth.username
      this.loading = true
      this.$store.dispatch('user/getListUserTrustees', { user }).then(res => {
        // this.users = res
        this.loading = false
      })
    },
    deletePermissions ({ user, acl }) {
      this.$emit('deletePermissionClicked', { user, acl })
    },
    editPermissions ({ user, acl }) {
      this.$emit('editPermissionClicked', { user, acl })
    },
    getPartitionPermissions ({ acl }) {
      const perm = this.$store.getters['acl/getPermissions']({ acl })
      const c = perm.canCreateObjects
      const r = perm.canListObjects
      const u = perm.canUpdateObjects
      const d = perm.canDeleteObjects

      return {
        c: {
          active: c,
          color: c ? 'blue' : 'grey',
          label: this.$t('perm.object_create')
        },
        r: {
          active: r,
          color: r ? 'blue' : 'grey',
          label: this.$t('perm.object_list')
        },
        u: {
          active: u,
          color: u ? 'blue' : 'grey',
          label: this.$t('perm.object_update')
        },
        d: {
          active: d,
          color: d ? 'blue' : 'grey',
          label: this.$t('perm.object_delete')
        }
      }
    },
    optionsClick (item) {
      this.selectedRow = item.usr

      this.actionsList = [
        {
          id: 'edit',
          // condition: this.needsCSRP10(element.info.type),
          icon: 'edit',
          title: this.$tc('edit'),
          action: () => this.editPermissions({ user: item.usr, acl: item.acl })
        },
        {
          id: 'delete_outline',
          // condition: !!(this.canCreateObjects && this.isExportable({ attr: element.info.attr })),
          icon: 'delete_outline',
          title: this.$tc('delete'),
          action: () => this.deletePermissions({ user: item.usr, acl: item.acl })
        }
      ]
    },
    closeMenu () {
      this.selectedRow = null
    }
  }
}
</script>

<style>
  .border-radius-0 {
    border-radius: 0 !important;
  }
</style>
